<template>
<div class="content">
    <toolbar v-bind:selection="toolbar" title="Nuevo colmenar" />

    <v-form ref="form" v-model="valid" lazy-validation>
    <!--form v-on:submit.prevent="submitForm"-->


        <!--div-- class="position-relative form-group">
            <label for="name" class="">Nombre</label>
            <input name="name"
                   id="name"
                   required
                   placeholder="Nombre del colmenar"
                   type="text"
                   class="form-control" v-model="infoform.name">
        </div-->

        <v-text-field
                v-model="infoform.name"
                color="orange"
                label="Nombre del colmenar*"
                :rules="nameRules"
        ></v-text-field>

        <!--div-- class="position-relative form-group">
            <label for="localization" class="">Localización</label>

            <input type="text"
                   id="localization"
                   required
                   class="form-control"
                   placeholder="Zona, ciudad..."
                   v-model="infoform.localization">

        </div-->

        <v-text-field
                v-model="infoform.localization"
                color="orange"
                label="Localización"

        ></v-text-field>

        <p><b>Descripción</b></p>
        <v-col class="col" cols="12" md="6">
            <v-textarea
                    class="nonebold"
                    solo
                    id="description"
                    name="description"
                    label="Información adicional"
                    v-model="infoform.description"
            ></v-textarea>
        </v-col>


        <!--p for="description" class="">Descripción</p>
        <textarea-- name="description" rows="5" id="description" class="form-control"
                  placeholder="Información adicional"
                  v-model="infoform.description"></textarea-->


        <!--div class="position-relative form-group">
            <label for="description" class="">Descripción</label>
            <textarea name="description" rows="5" id="description" class="form-control"
                      placeholder="Información adicional"
                      v-model="infoform.description"></textarea>
        </div-->

        <loading v-bind:isloading="isloading" ></loading>

        <v-alert
                dense
                v-bind:type="alertForm"
                text
                :value="alert"
                transition="scale-transition"
        >
            {{responseform}}
        </v-alert>

        <v-btn :disabled="!valid" class="mr-4 btn-yellow" @click="validate">
            Aceptar
        </v-btn>

        <v-btn class="mr-4" @click="reset">
            Limpiar
        </v-btn>

    </v-form>

</div>

</template>

<script>
import auth from "@/libs/auth"

import toolbar from "@/components/Toolbar"
import loading from "@/components/Loader"
import axios from "axios";

export default {
    name: 'colmenar-nuevo',
    components: {loading,toolbar},
    data() {
        return {

            toolbar: {
              return: '0',
            },

            valid: true,

            nameRules: [
                v => !!v || 'Requerido',
                v => (v && v.length <= 25) || 'Debe ser inferior a 25 caracteres',
            ],


            infoform: {
                name: '',
                description: '',
                localization: ''
            },


           isloading:'',

           alertForm:'success',
            responseform:'',
            alert: false,


          /*  alertForm:'success',
            responseform:'',
            alert: false,

            infoform: {
                name: '',
                description: '',
                localization: ''
            }
            */
        }
    },
    created() {
        auth.getUserLogged()
      },
    methods:{
         validate () {
            this.$refs.form.validate()
            if(this.$refs.form.validate()){
                this.alert = false
                this.isloading = true
                axios.post('https://appws.panimiel.com/new/index.php/api/colmenar', this.infoform)
                     .then((response) => {
                     this.responseform = response.data
                     this.alertForm = 'success'
                     this.isloading=''
                     this.alert = true
                })
                .catch((error) => {
                    this.alertForm = 'error',
                    this.isloading=''

                    if (error.response.status != 500){
                        this.responseform = error.response.data
                    }else{
                        this.responseform = 'Error, no ha sido posible crear el colmenar.'
                    }
                     this.alert = true

                 })
             }
        },
          reset () {
            this.$refs.form.reset()
          },
    }
}

</script>